import React, { useContext } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

import heroBanner from '../../images/book-online-banner.jpg';
import { AppContext } from '../context';
import ServiceList from './ServiceList';
import CartItems from './CartItems';
import AddCartMobile from './AddCartMobile';

const BookingForm = () => {
  const { userAgent } = useContext(AppContext);

  return (
    <div className="BookingForm" style={{ backgroundImage: `url(${heroBanner})`}}>
      <Container>
        <Row>
          <Col md={12} lg={{ span: 8, offset: 2 }}>
            <h4 className="text-center mb-4">Choose the services</h4>
            <Card className='shadow border-0 overflow-hidden'>
              <Card.Body className="p-0">
                <Row>
                  <Col md={7} className="pr-md-0">
                    <ServiceList />
                  </Col>
                  { 
                    !userAgent.isMobile && 
                      <Col md={5} className="pl-md-0">
                        <CartItems />
                      </Col>
                  }
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      { userAgent.isMobile && <AddCartMobile /> }
    </div>
  );
};

export default BookingForm;